// extracted by mini-css-extract-plugin
export default {"main":"index_main_vOped","mainLeft":"index_mainLeft_PbA79","mainRight":"index_mainRight_sHn69"};